export default function Contact() {
  const contactMethods = [
    {
      title: "Email",
      value: "tejrajdevkota12@gmail.com",
      link: "mailto:tejrajdevkota12@gmail.com",
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
        </svg>
      ),
      gradient: "from-cyan-500 to-blue-500"
    },
    {
      title: "LinkedIn",
      value: "Connect with me",
      link: "https://www.linkedin.com/in/tejraj-devkota-058212321/",
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" />
        </svg>
      ),
      gradient: "from-purple-500 to-pink-500"
    },
    {
      title: "GitHub",
      value: "View my code",
      link: "https://github.com/Tejraj-co?tab=repositories",
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      ),
      gradient: "from-green-500 to-emerald-500"
    }
  ];

  return (
    <section id="contact" className="py-20 bg-blue-light text-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl font-bold text-blue-600 mb-6">
            Let's Work Together
          </h2>
          <p className="text-lg sm:text-xl text-gray-700 max-w-2xl mx-auto mb-4">
            Ready to bring your next project to life?
          </p>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            I'm always excited to collaborate on innovative projects and help turn your ideas into reality. 
            Let's create something amazing together !
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {contactMethods.map((method, i) => (
            <a key={i} href={method.link} className={`group bg-gradient-to-br from-sky-500/20 to-cyan-500/20 backdrop-blur-sm rounded-2xl p-8 hover:from-sky-600/30 hover:to-cyan-600/30 transition-all duration-300 hover:-translate-y-4 border border-sky-300/30 hover:border-sky-400/50 text-center animate-slide-up delay-${(i + 1) * 100} hover:scale-105`}>
              <div className={`w-16 h-16 bg-gradient-to-r ${method.gradient} rounded-2xl flex items-center justify-center text-white mx-auto mb-6 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300`}>
                {method.icon}
              </div>
              <h3 className="text-xl font-bold text-sky-800 mb-3 group-hover:text-sky-600 transition-colors">🔗 {method.title}</h3>
              <p className="text-sky-700 group-hover:text-sky-600 transition-colors">{method.value}</p>
            </a>
          ))}
        </div>
        
        <div className="animate-slide-up delay-500">
          <div className="bg-gradient-to-br from-sky-400/20 to-cyan-400/20 backdrop-blur-sm rounded-3xl p-8 border border-sky-300/40 hover:border-sky-400/60 max-w-2xl mx-auto shadow-xl transition-all duration-300 hover:shadow-2xl">
            <h3 className="text-3xl font-bold text-sky-700 mb-6 text-center">Send Me a Message</h3>
            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sky-800 font-medium mb-2">Name</label>
                  <input type="text" className="w-full px-4 py-3 bg-white/90 border border-sky-200 rounded-lg text-gray-800 placeholder-sky-400 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 focus:bg-white transition-all" placeholder="Your Name" />
                </div>
                <div>
                  <label className="block text-sky-800 font-medium mb-2">Email</label>
                  <input type="email" className="w-full px-4 py-3 bg-white/90 border border-sky-200 rounded-lg text-gray-800 placeholder-sky-400 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 focus:bg-white transition-all" placeholder="your@email.com" />
                </div>
              </div>
              <div>
                <label className="block text-sky-800 font-medium mb-2">Subject</label>
                <input type="text" className="w-full px-4 py-3 bg-white/90 border border-sky-200 rounded-lg text-gray-800 placeholder-sky-400 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 focus:bg-white transition-all" placeholder="Project Discussion" />
              </div>
              <div>
                <label className="block text-sky-800 font-medium mb-2">Message</label>
                <textarea rows="5" className="w-full px-4 py-3 bg-white/90 border border-sky-200 rounded-lg text-gray-800 placeholder-sky-400 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 focus:bg-white transition-all resize-none" placeholder="Tell me about your project..."></textarea>
              </div>
              <div className="text-center">
                <button type="submit" className="px-8 py-4 bg-gradient-to-r from-sky-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-sky-600 hover:to-cyan-600 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
